import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'IBANExport'
})
export class IBANExportPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value == null) return value;
    const s = value;
    return s.replace(/\s+/g,'');
  }
}
